var aboutController = (function () {
    function aboutController(env, $filter, DTS, $stateParams, $state) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.profileLoaded = true;
        this.data = {
            _id: "Terms_Of_Use",
            _rev: "1-0a5e3e546bfdee7666d6047ae3411199",
            terms: [
                {
                    tou: "The following are the terms of an agreement between you and IBM. By accessing, or using this Web site, you acknowledge that you have read, understand, and agree to be bound by these terms and to comply with all applicable laws and regulations, including export and re-export control laws and regulations. If you do not agree to these terms, please do not use this Web site. IBM may, without notice to you, at any time, revise these Terms of Use and any other information contained in this Web site. IBM may also make improvements or changes in the products, services, or programs described in this site at any time without notice.",
                    created_by: "Pasha",
                    created_date: "2018-01-30T21:00:00.000Z",
                    version: 12,
                    effective_date: "2018-10-30T21:00:00.000Z"
                },
                {
                    tou: "This Web site contains proprietary notices and copyright information, the terms of which must be observed and followed. Please see the tab entitled “Copyright and trademark information” for related information.",
                    created_by: "Ilya Aderiho",
                    created_date: "2018-01-30T21:00:00.000Z",
                    version: 13,
                    effective_date: "2018-08-30T21:00:00.000Z"
                },
                {
                    tou: "IBM grants you a non-exclusive, non-transferable, limited permission to access and display the Web pages within this site as a customer or potential customer of IBM provided you comply with these Terms of Use, and all copyright, trademark, and other proprietary notices remain intact. You may only use a crawler to crawl this Web site as permitted by this Web site’s robots.txt ",
                    created_by: "Dmitry Mitsaliuk",
                    created_date: "2018-06-30T21:00:00.000Z",
                    version: 14,
                    effective_date: "2018-11-30T21:00:00.000Z"
                },
                {
                    tou: "IBM grants you a non-exclusive, non-transferable,  ",
                    created_by: "Matthew Rogers",
                    created_date: "2018-04-30T21:00:00.000Z",
                    version: 15,
                    effective_date: "2018-01-30T21:00:00.000Z"
                }
            ]
        };
    }
    aboutController.prototype.$onInit = function () {
        this.correctTerms = this.data.terms[this.data.terms.length - 1];
    };
    aboutController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state'];
    return aboutController;
}());
var aboutComponent = (function () {
    function aboutComponent() {
        this.templateUrl = 'about.html';
        this.controllerAs = 'vm';
        this.controller = aboutController;
    }
    return aboutComponent;
}());
angular
    .module('application')
    .component('aboutSection', new aboutComponent());

//# sourceMappingURL=about.component.js.map
